import { createReducer, on } from '@ngrx/store';
import * as fromPaymentsActions from '../actions';
import { INotifyOutstandingResponse } from '../models/notify-outstanding-response.model';

export const notifyOutstandingFeatureKey = 'notifyOutstanding';

export interface NotifyOutstandingState {
  success: INotifyOutstandingResponse | null;
  failure: any | null;
  loading: boolean;
}

export const initialState: NotifyOutstandingState = {
  success: null,
  failure: null,
  loading: false
};

export const notifyOutstandingReducer = createReducer(
  initialState,
  on(fromPaymentsActions.notifyAllOutstanding, (state) => ({
    ...state,
    success: null,
    failure: null,
    loading: true
  })),
  on(fromPaymentsActions.notifyAllOutstandingSuccess, (state, { response }) => ({
    ...state,
    success: response,
    failure: null,
    loading: false
  })),
  on(fromPaymentsActions.notifyAllOutstandingFailure, (state, { error }) => ({
    ...state,
    success: null,
    failure: error,
    loading: false
  }))
);
